import React from "react";
import { Initials, LogoImage } from "./SelectionGrid.styles";

export interface ItemLogoProps {
  label: string;
  logoSrc?: string;
  initials?: string;
  /** Colour behind the initials: data, passed through. */
  accent?: string;
  /** Square edge in rem (default 1.375). */
  size?: number;
  className?: string;
}

export const deriveInitials = (label: string): string =>
  label
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

/** A logo image, or initials on an accent colour. Decorative: the name is always shown beside it. */
export const ItemLogo: React.FC<ItemLogoProps> = ({ label, logoSrc, initials, accent, size = 1.375, className }) =>
  logoSrc ? (
    <LogoImage className={className} src={logoSrc} alt="" $size={size} data-testid="item-logo" />
  ) : (
    <Initials className={className} $accent={accent} $size={size} aria-hidden="true" data-testid="item-logo">
      {initials ?? deriveInitials(label)}
    </Initials>
  );
